import enUs from './en-US';
import frFr from './fr-FR';

export const messages = {
  'fr-FR': frFr,
  'en-US': enUs,
  'en-GB': enUs,
};

export const TRANSLATION_KEY = 'page_home';
